module.exports = __webpack_public_path__ + "static/media/igi_discount.6166adb6.png";